import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Wrapper from '../../components/Wrapper';
import LanguageLabalesTab from './components/LanguageLabalesTab';
import LocalesTab from './components/LocalesTab';
import HowToUseTab from './components/HowToUseTab';
import { useTranslation } from '../../hooks/useTranslation';
import './index.scss';
import { useSelector } from 'react-redux';

const LanguageManagement = () => {
  const {t} = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState('labels');
  const userInfo = useSelector(state => state?.rootReducer?.loginSlice?.user);

  // Load initial tab from query params
  useEffect(() => {
    const tabFromParams = searchParams.get('tab');
    if (tabFromParams && (tabFromParams === 'labels' || tabFromParams === 'locales' || tabFromParams === 'instructions')) {
      setActiveTab(tabFromParams);
    }
  }, [searchParams]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    // Update query params
    setSearchParams({ tab });
  };

  return (
    <Wrapper>
      
      <div className="language-management">
        {/* Tabs Navigation */}
        <div className="language-management__tabs">
          <button
            className={`language-management__tab ${activeTab === 'labels' ? 'active' : ''}`}
            onClick={() => handleTabChange('labels')}
          >
            {t('languageManagement.tabs.languageLabels')}
          </button>
          <>
            {
              userInfo?.is_global && (
                <button
                  className={`language-management__tab ${activeTab === 'locales' ? 'active' : ''}`}
                  onClick={() => handleTabChange('locales')}
                >
                  {t('languageManagement.tabs.locales')}
                </button>
              )
            }
          </>
          <button
            className={`language-management__tab ${activeTab === 'instructions' ? 'active' : ''}`}
            onClick={() => handleTabChange('instructions')}
          >
            How to Use
          </button>
        </div>

        {/* Tab Content */}
        {activeTab === 'labels' && <LanguageLabalesTab />}
        {activeTab === 'locales' && <LocalesTab />}
        {activeTab === 'instructions' && <HowToUseTab />}
      </div>
    </Wrapper>
  );
};

export default LanguageManagement;
